import React from 'react';

const Asesor = (props) => (
  <div className='panel panel-default custom bordeado asesor'>
    <div className='panel-body'>
      <div className='titulo-asesor'>Tu asesor en esta compra sera</div>
      <h4 style={{ margin: '9px 0 3px 0' }}>{props.datosAsesor.nombre}</h4>
      <div className='info'>
        Direccion:
        <span>{props.datosAsesor.direccion}</span>
      </div>
      <div className='info'>
        Telefono:
        <span>{props.datosAsesor.telefono}</span>
      </div>
      <div className='info'>
        Mail:
        <span>{props.datosAsesor.email}</span>
      </div>
    </div>
    <div className='aclaracion'>
      Todas las dudas respecto a tu compra las puedes ver con tu asesor en sus oficinas o telefonicamente en el horario
      <div className='resaltado'>{props.datosAsesor.horarioAtencion}</div>
    </div>
  </div>
);

export default Asesor;
